import {useEffect, useState} from "react";
import {Card, Col, Empty, Row, Image, notification} from "antd";
import {Button, FontAwesomeIcon, Icon, Loading, Modal} from "../../../components";
import ActionBar from "../../../layout/ActionBar";
import {useParams} from "react-router-dom";
import {apiError, handleRequest} from "../../../utils";
import {samplesApi} from "../../../api";
import _ from "lodash";
import SamplesFormEdit from "../components/Forms/SamplesFormEdit";
import DOMPurify from "dompurify";
import SamplesSearchBar from "../components/Search/SamplesSearchBar";
import {useCan} from "../../../hooks";

function Samples()
{
    const can = {
        edit: useCan('samplesEdit'),
    };

    const {type} = useParams();

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(false);

    const [items, setItems] = useState([]);

    const [itemEdit, setItemEdit] = useState({});

    const [filter, setFilter] = useState({});

    //Model
    const [openModal, setOpenModal] = useState({
        edit  : false,
        view  : false,
    });

    const handleModalOpen = (modal) => {
        openModal[modal] = true;
        setOpenModal({...openModal})
    }

    const handleModalClose = (modal) => {
        openModal[modal] = false;
        setOpenModal({...openModal});
    }

    const eventsHandler = {
        load: async () => {

            setLoading(true);

            setItems([]);

            let [error, response] = await handleRequest(samplesApi.gets(type, filter));

            let message = apiError(`Load dữ liệu thất bại`, error, response);

            if (!message)
            {
                setItems(response.data);
                setError(false)
            }
            else
            {
                setItems([]);
                setError(true);
            }

            setLoading(false);
        },
        save: async (data, item) => {
            if (!item?.id) {
                notification.error({message: 'Lỗi', description: 'Không có thông tin element để cập nhật'});
                return;
            }

            data.id = item.id;

            let [error, response] = await handleRequest(samplesApi.update(data));

            let message = apiError(`Cập nhật đặc tả thất bại`, error, response);

            if (!message)
            {
                notification.success({message: 'Thành công', description: `Cập nhật đặc tả thành công`});

                for (const [index, item] of Object.entries(items)) {
                    if (item.id === itemEdit.id)
                    {
                        if (response.data?.content) items[index].content = response.data.content;
                    }
                }
                setItems(items)
                handleModalClose('edit')
            }
        },
        onClickEdit: (item) => {
            setItemEdit(item);
            handleModalOpen('edit');
        },
        onClickView: (item) => {
            setItemEdit(item);
            handleModalOpen('view');
        },
        onSearchChange: (key, value, reset = false) => {
            setFilter({
                ...filter,
                [key]: value,
                page: 1,
            })
            eventsHandler.load()
        }
    }

    useEffect(() => {
        eventsHandler.load()
    }, [type, filter])

    return (
        <>
            <ActionBar title={'Element'}>
                <Button outline to={'/samples/header'}>Header</Button>
                <Button outline to={'/samples/top-bar'}>Top Bar</Button>
                <Button outline to={'/samples/navigation'}>Navigation</Button>
                <Button outline to={'/samples/widget'}>Widget</Button>
                <Button outline to={'/samples/footer'}>Footer</Button>
                <Button outline small onClick={eventsHandler.load} style={{fontSize:'16px'}}>{Icon.reload}</Button>
            </ActionBar>
            <SamplesSearchBar filter={filter} onChange={eventsHandler.onSearchChange} />
            <div className="container mt-2">
                {loading && <Loading/>}
                {error && <div className="container text-center">
                    <div className="content">
                        <Empty description={<span>Không có element</span>}></Empty>
                    </div>
                </div>}
                <Row gutter={16}>
                    {!_.isEmpty(items) && items.map((item, index) => (
                        <Col span={6} className="mb-3">
                            <Card
                                title={item.title}
                                cover={<Image src={item.image} alt="" />}
                                actions={[
                                    <Button outline small blue onClick={() => eventsHandler.onClickEdit(item)} leftIcon={<FontAwesomeIcon icon='fal fa-pen-line'/>}></Button>,
                                    <Button outline small green onClick={() => eventsHandler.onClickView(item)} leftIcon={<FontAwesomeIcon icon='fal fa-eye'/>}></Button>,
                                ]}
                            ></Card>
                        </Col>
                    ))}
                </Row>
            </div>
            {
                (itemEdit?.id && openModal.edit) && <Modal title="Cập nhật ĐTLT" size={'xl'} visible={openModal.edit} onCancel={() => {handleModalClose('edit')}}>
                    {
                        can.edit && <SamplesFormEdit item={itemEdit} onHandleSubmit={eventsHandler.save} />
                    }
                    {
                        !can.edit && <><p>Bạn không có quyền sử dụng chức năng này</p></>
                    }
                </Modal>
            }
            {
                (itemEdit?.id && openModal.view) && <Modal title="Đặc tả" size={'xl'} visible={openModal.view} onCancel={() => {handleModalClose('view')}}>
                    <div className="content-html" style={{wordBreak : 'break-word'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(itemEdit.content) }} />
                </Modal>
            }
        </>
    )
}

export default Samples;